import React from "react";
import { Pagination, PaginationProps } from "@mui/material";
import { NEUTRAL, ORANGE, PLUM } from "../styles/brandTokens";

const StyledPagination: React.FC<PaginationProps> = (props) => (
  <Pagination
    siblingCount={1}
    boundaryCount={1}
    {...props}
    sx={{
      "& .MuiPaginationItem-root": {
        borderRadius: 0,
        fontWeight: 500,
        fontSize: "14px",
        fontVariantNumeric: "tabular-nums",
        minWidth: 8,
        height: 22,
        margin: "0 3px",
        color: NEUTRAL.textSecondary,
        "&.Mui-selected": {
          color: PLUM.rail,
          fontWeight: 700,
          borderBottom: `2px solid ${ORANGE.main}`,
          backgroundColor: "transparent",
          borderRadius: 0,
          boxShadow: "none",
        },
        "&:not(.Mui-selected):hover": {
          backgroundColor: NEUTRAL.hover,
        },
      },
      "& .MuiPaginationItem-previousNext": {
        color: NEUTRAL.textMuted,
        background: "transparent",
        borderRadius: "50%",
        minWidth: 8,
        height: 20,
      },
      ...props.sx, // allow further sx overrides if needed
    }}
  />
);

export default StyledPagination;